import React from "react";
import { SignInForm } from "./SignInForm";
import { SignInHeader } from "./SignInHeader";
import {
  StyledFlexContainer,
  StyledStackContainer,
} from "./SignInScreen.styles";

export function SignInScreen() {
  return (
    <StyledFlexContainer direction="column" justify="center" align="center">
      <StyledStackContainer>
        <SignInHeader />
        <SignInForm />
      </StyledStackContainer>
    </StyledFlexContainer>
  );
}
